<template>
  <div
    v-if="cartItemValidationResult.exceedStock"
    class="small message-indicator"
  >
    <template v-if="cartItemValidationResult.stockAvailable <= 0">
      <p class="mb-0 text-end text-danger font-weight-bold">
        {{ $t('ATM.CART.PRODUCT_WITHOUT_STOCK') }}
      </p>
    </template>
    <template v-else>
      <p class="mb-0 text-end text-danger font-weight-bold text-end">
        {{
          $tc('ATM.CART.AVAILABLE_STOCK', cartItemValidationResult.stockAvailable, {
            quantity: cartItemValidationResult.stockAvailable,
          })
        }}
      </p>
      <p class="mb-0 text-end">
        {{
          $tc('ATM.CART.QUANTITY_IN_CART', cartItemValidationResult.cartQuantity, {
            quantity: cartItemValidationResult.cartQuantity,
          })
        }}
      </p>
    </template>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    isItemKit: {
      type: Boolean,
      default: false,
    },
    cartItemValidationResult: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {}
  },

  computed: {},

  methods: {},
}
</script>

<style lang="scss" scoped>
.message-indicator {
  border-left: 1px solid var(--danger);
  padding-left: 5px;
}
</style>
